import { PageHeader } from '@/components/app/PageHeader'
import { Card } from '@/components/ui/Card'
import { EmptyState } from '@/components/ui/States'

/**
 * Phase 2, undefined. The nav slot and route are reserved so the shape of the
 * app is complete (docs/03-page-specs.md §11).
 *
 * The one constraint that must survive into whatever gets designed:
 * re-extraction has to diff against manual edits and require confirmation
 * before overwriting them. Silently discarding a reviewer's edits is the
 * failure mode for this page.
 */
export function BrandPage() {
  return (
    <>
      <PageHeader
        title="Brand profile"
        description="Voice, tone, and messaging guidance for this client."
      />
      <Card>
        <EmptyState
          title="Not built yet"
          description="Brand profile is Phase 2 and needs a design pass before it is built. The route exists so the navigation is complete."
        />
      </Card>
    </>
  )
}
